<template>
  <div v-loading="loading">
    <el-form ref="form" :model="form" label-width="250px" @submit.prevent="onSubmit" style="margin: 20px; width: 60%; min-width: 600px">
      <el-form-item label="Sensitivity">
        <el-input v-model="form.sensitivity" type="number"></el-input>
      </el-form-item>
      <el-form-item style="margin-top: 10px">
        <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Axios from "axios"
import echarts from "echarts"
import IOService from "@/api/io.service"
import SettingsService from "@/api/settings.service"
import constants from "@/common/constants/system"

export default {
  data() {
    return {
      loading: false,
      form: {
        enabled: false,
        sensitivity: ""
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      },
      user: this.$session.get("User")
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    verifySettings() {
      if (isNaN(parseInt(this.form.sensitivity)) || parseInt(this.form.sensitivity) < 0 || parseInt(this.form.sensitivity) > 100) {
        const h = this.$createElement
        this.$notify({
          title: "Sensitivity",
          message: "Value not valid.  Value should be between 0 and 100",
          type: "error"
        })
        return false
      }
      return true
    },
    saveDataToPanel() {
      if (!this.verifySettings()) return
      this.loading = true
      Axios.all([SettingsService.changeSetting(this.user.activeZone, "Settings.Compensator.Sensitivity", this.form.sensitivity)])
        .then(
          Axios.spread((sensitivityResponse) => {
            //The system should update in 10 seconds.
            this.loading = false
            if (sensitivityResponse.data.result != "success") {
              const h = this.$createElement
              this.$notify({
                title: "Compensator",
                message: "Error trying to save data to panel",
                type: "error"
              })
            } else {
              this.$notify({
                title: "Compensator",
                message: "Settings Saved to Panel",
                type: "info"
              })
            }
          })
        )
        .catch(() => {
          this.loading = false
          const h = this.$createElement
          this.$notify({
            title: "Compensator",
            message: "Error trying to save data to panel",
            type: "error"
          })
        })
    },
    getData() {
      //Axios.defaults.baseURL = 'http://192.168.137.233:3000';
      Axios.all([IOService.getSettings(this.user.activeZone)]).then(
        Axios.spread((settingsResponse) => {
          this.form.sensitivity = settingsResponse.data.compensator.sensitivity
        })
      )
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  float: left;
}
/*.chart div {
        height: 400px;
        float: left;
    }*/

.el-col {
  padding: 30px 20px;
}
</style>



// WEBPACK FOOTER //
// Compensator.vue?0ff71c93